module.exports = __webpack_public_path__ + "img/more_specific.27597353.jpg";